import {START_FORGOTPASSWORD,END_FORGOTPASSWORD} from "./action";

const initState   =     {
    isProgress:false,
    error:null,
    success:null
}

export  function forgotPasswordReducer(state=initState,action){
    switch(action.type){
        case START_FORGOTPASSWORD:
            return {
                ...state,
                isProgress:true,
                error:null,
                success:null
            };
        case END_FORGOTPASSWORD:
            return {
                ...state,
                isProgress:false,
                error:action.payload.error,
                success:action.payload.success
            }
        default:
            return state;
    }
}